var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 22C19.0887 22 20.75 20.3362 20.75 18.25C20.75 16.1637 19.0887 14.5 17 14.5C14.9112 14.5 13.25 16.1637 13.25 18.25C13.25 20.3362 14.9112 22 17 22Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0212 15.9825C27.7267 14.5429 27.1511 13.1756 26.3275 11.9587C25.5182 10.7616 24.4871 9.73053 23.29 8.92125C22.073 8.09791 20.7057 7.52237 19.2662 7.2275C18.5101 7.07416 17.7403 6.99877 16.9688 7.0025V4.5L12 8.25L16.9688 12V9.5025C17.5737 9.5 18.1788 9.5575 18.7625 9.6775C19.8813 9.90676 20.944 10.354 21.89 10.9938C22.823 11.6228 23.6259 12.4258 24.255 13.3587C25.2317 14.8028 25.7525 16.5067 25.75 18.25C25.7498 19.4199 25.5161 20.5779 25.0625 21.6562C24.8419 22.1757 24.5724 22.6729 24.2575 23.1413C23.9414 23.6067 23.5823 24.0416 23.185 24.44C21.975 25.6477 20.4389 26.4762 18.765 26.8237C17.6009 27.0588 16.4016 27.0588 15.2375 26.8237C14.1182 26.5943 13.055 26.1466 12.1087 25.5063C11.1769 24.8778 10.3747 24.0756 9.74625 23.1438C8.77069 21.6982 8.24963 19.994 8.25 18.25H5.75C5.75133 20.4921 6.42111 22.6829 7.67375 24.5425C8.48356 25.7377 9.51358 26.7677 10.7087 27.5775C12.5658 28.8343 14.7576 29.5041 17 29.5C17.7616 29.4999 18.5212 29.4233 19.2675 29.2712C20.7059 28.9742 22.0724 28.3989 23.29 27.5775C23.8878 27.1747 24.4451 26.7146 24.9538 26.2038C25.4631 25.693 25.9235 25.1355 26.3287 24.5387C27.5845 22.6822 28.2539 20.4914 28.25 18.25C28.2499 17.4884 28.1733 16.7288 28.0212 15.9825Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetButton);
export default __webpack_public_path__ + "static/media/reset-button.d7c8f19121506b04e727f392d4f25b49.svg";
export { ForwardRef as ReactComponent };